import { gql } from "@apollo/client";

export const productListQuery = gql`
  query productList(
    $filter: ProductFilterInput
    $pagination: PaginationInput
    $sort: ProductSortInput
  ) {
    productList(filter: $filter, pagination: $pagination, sort: $sort) {
      edges {
        id
        name
        price
        inventory
        description
        manufacturer {
          id
          name
        }
        categories {
          id
          name
        }
      }
      pageInfo {
        total
      }
    }
  }
`;
